import React, { Fragment, useRef } from "react";
import { Button } from "@material-ui/core";
import Theme, { useStyles } from "./Theme.js";
import UPLOAD from "../images/pictos-ok/UPLOAD.svg";

const FindPictureButton = (props) => {
  const hiddenFileInput = useRef(null);
  const classes = useStyles();

  const handleUpload = (event) => {
    const fileUploaded = event.target.files[0];
    props.handleChange(fileUploaded);
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  return (
    <Fragment>
      <Button
        className={classes.themeButton2}
        classes={{ label: "column textetakephoto" }}
        onClick={handleClick}
      >
        <img src={UPLOAD} style={{ maxWidth: 40, marginBottom: 5 }} />
        Upload un fichier
      </Button>
      <input
        type="file"
        accept="image/*"
        multiple={false}
        ref={hiddenFileInput}
        onChange={handleUpload}
        style={{ display: "none" }}
      />
    </Fragment>
  );
};

export default FindPictureButton;
